import React from 'react';
import cx from 'classnames';
import Information from '../Icons/Information';
import AlertWarning from '../Icons/AlertWarning';

import styles from './Callout.module.scss';

export interface Props {
  children?: React.ReactNode;
  className?: Parameters<typeof cx>[0];
  icon?: React.ReactElement;
  noIcon?: boolean;
  title?: string;
  warning?: boolean;
  actions?: React.ReactNode;
  variant?: 'attention' | 'success' | 'error' | 'warning';
}

export const Callout: React.FC<Props> = ({
  children,
  title,
  icon,
  noIcon,
  className,
  warning,
  actions,
  variant,
}) => {
  const defaultIcon = warning ? (
    <AlertWarning className={styles.icon} />
  ) : (
    <Information className={styles.icon} />
  );

  return (
    <div
      className={cx(
        styles.callout,
        variant && styles.decorativeBorder,
        variant && styles[variant],
        className,
      )}
    >
      {!noIcon &&
        (icon
          ? React.cloneElement(icon, { className: styles.icon })
          : defaultIcon)}
      <div>
        {title && <p className={styles.title}>{title}</p>}
        <p className={styles.content}>{children}</p>
        {actions && <div className={styles.actions}>{actions}</div>}
      </div>
    </div>
  );
};

Callout.displayName = 'Callout';
export default Callout;
export { styles };
